module.exports = __webpack_public_path__ + "static/media/bonus_200_mob.1748d19e.png";